<template>
  <v-app>
    <zp-header v-if="user"></zp-header>
    <zp-accept-terms></zp-accept-terms>
    <v-main style="background-color: #F5F5F5;">
      <div v-if="loading" style="height: 100%;" class="d-flex justify-center align-center">
        <v-progress-circular
          :width="3"
          :size="60"
          color="blue"
          indeterminate
        ></v-progress-circular>
      </div>
      <router-view v-else style="height: 100%;" class="pa-4"></router-view>
      <zp-invite v-if="user"></zp-invite>
      <zp-trial v-if="user"></zp-trial>
      <zp-modal-renew v-if="user"></zp-modal-renew>
    </v-main>
  </v-app>
</template>

<script>
import { mapState } from 'vuex'
import ZpAcceptTerms from './components/AcceptTerms'
import ZpHeader from './components/Header'
import ZpInvite from './components/Invite'
import ZpTrial from './components/Trial'
import ZpModalRenew from './components/ModalRenew'

export default {
  name: 'App',
  components: {
    ZpHeader,
    ZpAcceptTerms,
    ZpInvite,
    ZpTrial,
    ZpModalRenew
  },
  data () {
    return {
      loading: true,
      FB: {},
      year: new Date().getFullYear()
    }
  },
  computed: {
    ...mapState({
      user: state => state.auth.user,
      inviteId: state => state.team.inviteId
    })
  },
  mounted () {
    let _this = this
    this.$nextTick(() => {
      window.gapi.load('auth2', () => {
        window.auth2 = window.gapi.auth2.init({
          client_id: '547225378779-fb3fv8len93a0fk6eucv532iecg2n0ej.apps.googleusercontent.com',
          cookiepolicy: 'single_host_origin'
        })
      })

      window.fbAsyncInit = function () {
        window.FB.init({
          appId      : process.env.VUE_APP_FB_CLIENT_ID || '374353543586931',
          cookie     : true,
          xfbml      : true,
          version    : 'v8.0'
        })
        window.FB.AppEvents.logPageView()
        _this.FB = window.FB
        console.log('FB SDK was initialized as mixin')
      };
      (function (d, s, id) {
        let js, fjs = d.getElementsByTagName(s)[0]
        if (d.getElementById(id)) { return }
        js = d.createElement(s); js.id = id
        js.src = '//connect.facebook.net/en_US/sdk.js'
        fjs.parentNode.insertBefore(js, fjs)
      }(document, 'script', 'facebook-jssdk'))
    })
  },
  async created () {
    this.loading = true
    this.$store.commit('team/SET_INVITE_ID', this.$route.query.invite)
    await this.$store.dispatch('auth/fetchUser')
    this.loading = false
  }
}
</script>

<style lang="scss">
.text-center {
  text-align: center;
}
.pointer {
  cursor: pointer;
}
.v-data-footer {
  justify-content: center !important;
}
</style>